export const CUSTOM_MIX_PRODUCT_ID_PREFIX = 'CUSTMIX';

export const isCustomMixProduct = (productID?: string): boolean =>
  productID?.startsWith(CUSTOM_MIX_PRODUCT_ID_PREFIX) ?? false;
